import { render, staticRenderFns } from "./SouscriptionAssurance.vue?vue&type=template&id=2ad993de"
import script from "./SouscriptionAssurance.vue?vue&type=script&lang=js"
export * from "./SouscriptionAssurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports